import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SafeUrl } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class ProfileImageService {
  private profileImageUrlSubject: BehaviorSubject<string> = new BehaviorSubject<string>('assets/img/user.svg');
  public profileImageUrl$: Observable<string> = this.profileImageUrlSubject.asObservable();

  constructor(private http: HttpClient) {}

  setProfileImageUrl(url: string): void {
    this.profileImageUrlSubject.next(url);
  }

  getProfileImage(userId: number): Observable<Blob> {
    const url = `${environment.BACKEND}profile/serve-image/${userId}`;
    return this.http.get(url, { responseType: 'blob' });
  }

  uploadProfileImage(formData: FormData): Observable<any> {
    const url = `${environment.BACKEND}profile/upload`;
    return this.http.post(url, formData);
  }

  deleteProfileImage(userId: number): Observable<any> {
    const url = `${environment.BACKEND}profile/delete-image/${userId}`;
    return this.http.delete(url);
  }
}